// extracted by mini-css-extract-plugin
export default {"controls":"DetailControls_controls__ufmmh","btn--add":"DetailControls_btn--add__5um7T","btn--remove":"DetailControls_btn--remove__NvvsE","link":"DetailControls_link__61hsY"};